import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {AdminService} from '../services/admin.service';
import {GlobalDataService} from '../../housekeeping/services/global-data.service';
import { UserForm  } from '../models/data-model';
@Component({
  selector: 'app-details',
  templateUrl: '../views/details.component.html',
  styleUrls: ['../css/details.component.css']
})
export class DetailsComponent implements OnInit {
  public userObj= new UserForm('','','','',true,'',true,{id:'',code:'',description:''},[],{id:'',zone:'',description:''});
  public adminid: any;
  public userTZ='';
  public dealerName='';
  public dealerCode='';
  public access='';
  public timezoneDesc='';
  public notification="";
  constructor(public _adminService: AdminService,public _router: Router, public activeroute: ActivatedRoute,private _globalService:GlobalDataService) { }

  ngOnInit() {
    if(sessionStorage.getItem('roleId')!=="SYSADM" && sessionStorage.getItem('roleId')!=="SUSER"){
            this._router.navigate(['dashboard'])
    }
      window.scrollTo(0, 0);
      this.userTZ = this._globalService.USER_TZ;
        this.activeroute.params.subscribe(
            params => {
                if (Object.keys(params).length != 0) {
                    this.adminid = params.id;
                    this.getAdminDetails()

                }
            });
  }
   /**
        * @author Sowmya
        * params adminId
        * @description get the user data
        */
    getAdminDetails() {

        this._adminService.getAdminDetails(this.adminid, (result) => {
            this.userObj = result;
            if(this.userObj.dealers.length != 0){
              this.dealerName=this.userObj.dealers[0].name;
              this.dealerCode=this.userObj.dealers[0].globalCode;
              }
              if(this.userObj.timezone != undefined){
              this.timezoneDesc=this.userObj.timezone.description;
              }
              if(this.userObj.leadNotification != undefined ){
             if(this.userObj.leadNotification ){
                 this.notification = "Yes";
             }else
              this.notification = "No";
             }else
             this.notification = "No";


        })
    }

    deleteUser(userobj){
        this._adminService.deleteUser(userobj.id, (result) => {
            if(result=='USER_DELETED_SUCCESSFULLY')
            this._router.navigate(['admin']);
        })
    }

}



// WEBPACK FOOTER //
// ./src/app/modules/admin/components/details.component.ts